export enum SortDirection {
  asc = "asc",
  desc = "desc",
}

export interface SortType {
  fieldName: string;
  direction: SortDirection;
}
